import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const TYPE_BADGE = {
  ARJ: "bg-rose-100 text-rose-800 border-rose-300",
  URJ: "bg-amber-100 text-amber-800 border-amber-300",
  KRJ: "bg-emerald-100 text-emerald-800 border-emerald-300",
  RLJ: "bg-violet-100 text-violet-800 border-violet-300",
  "Ar25-B": "bg-sky-100 text-sky-800 border-sky-300",
  "Ar25-M": "bg-cyan-100 text-cyan-800 border-cyan-300",
  Ar40: "bg-orange-100 text-orange-800 border-orange-300",
  RLR25: "bg-lime-100 text-lime-800 border-lime-300",
  HS25: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300",
  AJ15: "bg-indigo-100 text-indigo-800 border-indigo-300",
  "AJ25-B": "bg-teal-100 text-teal-800 border-teal-300",
  AJ12: "bg-pink-100 text-pink-800 border-pink-300",
  UJ12: "bg-yellow-100 text-yellow-800 border-yellow-300",
};

const FALLBACK_BADGES = [
  "bg-slate-100 text-slate-800 border-slate-300",
  "bg-red-100 text-red-800 border-red-300",
  "bg-green-100 text-green-800 border-green-300",
  "bg-blue-100 text-blue-800 border-blue-300",
  "bg-purple-100 text-purple-800 border-purple-300",
];

export const typeBadge = (code) => {
  if (TYPE_BADGE[code]) return TYPE_BADGE[code];
  let h = 0;
  for (let i = 0; i < (code || "").length; i++) h = (h * 31 + code.charCodeAt(i)) >>> 0;
  return FALLBACK_BADGES[h % FALLBACK_BADGES.length];
};

export const CHART_COLORS = ["#E11D48", "#D97706", "#059669", "#8B5CF6"];

const DEFAULT_JUMBO_TYPES = ["ARJ", "URJ", "KRJ", "RLJ", "AJ15", "AJ25-B", "AJ12", "UJ12"];
let JUMBO_SET = new Set(DEFAULT_JUMBO_TYPES);

export const setJumboTypes = (codes) => {
  JUMBO_SET = new Set(codes && codes.length ? codes : DEFAULT_JUMBO_TYPES);
};

export const JUMBO_TYPES = DEFAULT_JUMBO_TYPES;

export const doughSplit = (r) => {
  let jumbo = 0;
  let mini = 0;
  (r.dough_items || []).forEach((d) => {
    if (JUMBO_SET.has(d.dough_type)) jumbo += d.kg || 0;
    else mini += d.kg || 0;
  });
  return { jumbo, mini };
};

export const doughTotals = doughSplit;

export const rupiah = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(Math.round(n || 0));

export const fmt = (n) =>
  new Intl.NumberFormat("id-ID", { maximumFractionDigits: 1 }).format(n || 0);

export const idDate = (iso) => {  try {
    return new Date(iso + "T00:00:00").toLocaleDateString("id-ID", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
export const shortDate = (iso) => {
  try {
    const d = new Date(iso + "T00:00:00");
    const day = d.getDate();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = String(d.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  } catch {
    return iso;
  }
};

export const totalPax = (items = []) =>
  items.reduce((s, i) => s + (Number(i.pax) || 0), 0);
